import React from 'react';
import {Link} from '@mui/material';
import classNames from 'classnames';
import logo from '../../assets/images/lightLogo.png'

const LoginButtonGroup = ({
  isRegistration = false,
}) => {
  return (
    <>
      <div className='login-logo'>
        <img src={logo} alt="Logo" />
      </div>
      <div className="login-buttonGroup">
        <Link
          href="/#/"
        >
          <button
            className={classNames('login-groupButton', {
              'login-button-active': !isRegistration
            })}
          >
            Login
          </button>
        </Link>
        <Link
          href="/#/registration"
        >
          <button
            className={classNames('login-groupButton', {
              'login-button-active': isRegistration
            })}
          >
            Registrieren
          </button>
        </Link>
      </div>
    </>
  );
};

export default LoginButtonGroup;
